export enum VisitStatuses {
  SCHEDULED_VISIT = 'visit.status.scheduledVisit',
  VISIT_IN_PROGRESS = 'visit.status.visitInProgress',
  VISIT_REPORT = 'visit.status.visitReport'
}
